import { render, staticRenderFns } from "./DocumentOperationButtons.vue?vue&type=template&id=7f56c2d2&scoped=true&"
import script from "./DocumentOperationButtons.vue?vue&type=script&lang=js&"
export * from "./DocumentOperationButtons.vue?vue&type=script&lang=js&"
import style0 from "./DocumentOperationButtons.vue?vue&type=style&index=0&id=7f56c2d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56c2d2",
  null
  
)

export default component.exports